export default "__VITE_ASSET__CjrtCQlf__"